import { FC } from 'react';
import { VehicleManageForm } from '@components/portal/vehicle-list';
import { GuardedPage } from '@components/portal/common';
import { Permission } from '@services/role';

export const AddVehicle: FC = () => {
	return (
		<GuardedPage canActivate={(user) => user.hasPermission(Permission.VEHICLE_WRITE) && !user.isDriver()}>
			<VehicleManageForm mode="add" />
		</GuardedPage>
	);
};
